export default "__VITE_ASSET__CzERmVJu__"